/**
 * Generate the tailwind shades with
 * @see https://www.tailwindshades.com/
 */

module.exports = {
	container: {
		center: true,
		padding: "15px",
	},
	extend: {
		screens: {
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1330px",
			"2xl": "1330px",
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		fontFamily: {
			sans: ["Catamaran", "Montserrat", "arial", "sans-serif"],
			heading: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
			daysone: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
			catamaran: ["Catamaran", "Montserrat", "arial", "sans-serif"],
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			"body-text": "#333333",
			black: {
				DEFAULT: "#000000",
			},
			white: {
				DEFAULT: "#ffffff",
			},
			primary: {
				DEFAULT: "#031A89",
				50: "#818DC4",
				100: "#ECF5FD",
				200: "#8499FC",
				300: "#5D78FB",
				400: "#3557FB",
				500: "#0D35FA",
				600: "#0529D9",
				700: "#0422B1",
				800: "#031A89",
				900: "#021052",
				950: "#010A37",
				hover: "#818DC4",
			},
			secondary: {
				DEFAULT: "#429CEC",
				50: "#E9F3FD",
				100: "#ECF5FD",
				200: "#B1D6F7",
				300: "#8CC3F3",
				400: "#67AFF0",
				500: "#429CEC",
				600: "#1681DF",
				700: "#1163AC",
				800: "#0C4679",
				900: "#072947",
				950: "#051A2D",
				hover: "#B1D6F7",
			},
			accent: {
				DEFAULT: "#79C434",
				50: "#D7EFC1",
				100: "#CCEAB1",
				200: "#B8E291",
				300: "#A3D970",
				400: "#8ED150",
				500: "#79C434",
				600: "#5E9828",
				700: "#426B1C",
				800: "#273F11",
				900: "#0C1305",
				950: "#000000",
				hover: "#BCE19A",
				light: "#E4F3D6",
			},
		},
		lineHeight: {
			heading: "1.27",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
	},
};
